var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTechnicalSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 318.63 288.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#444;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "318.63 133.18 263.22 133.18 263.22 77.77 231.34 77.77 231.34 133.18 175.93 133.18 175.93 165.05 231.34 165.05 231.34 220.46 263.22 220.46 263.22 165.05 318.63 165.05 318.63 133.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M235.63,288.21a20.8,20.8,0,0,1-14.81-6.13L112.05,173.3A88.28,88.28,0,0,1,.36,80.32,21.74,21.74,0,0,1,14.73,61.67a21.76,21.76,0,0,1,23,5.11L61.07,90.12a6.56,6.56,0,0,0,9.26,0l19.8-19.79a6.57,6.57,0,0,0,0-9.26L66.78,37.73a21.78,21.78,0,0,1-5.11-23A21.74,21.74,0,0,1,80.32.36,88.29,88.29,0,0,1,171.05,119a11.39,11.39,0,0,1-21.35-7.92A65.52,65.52,0,0,0,84.15,22.9L106.23,45a29.32,29.32,0,0,1,0,41.46L86.43,106.22a29.34,29.34,0,0,1-41.45,0L22.9,84.15a65.52,65.52,0,0,0,88.3,65.51,11.39,11.39,0,0,1,12,2.62L235.63,264.69l30.43-30.42a11.38,11.38,0,1,1,16.1,16.09l-31.72,31.72A20.77,20.77,0,0,1,235.63,288.21Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnicalSupport);
export default __webpack_public_path__ + "static/media/technical-support.e426f3f97fe86d392bf46bfe987496fc.svg";
export { ForwardRef as ReactComponent };